import { AoiSpecialty, AreaOfInterest } from '../../../types';
import { OptionType } from '../../types';
import { AOIFormValues, AoiOptionType } from './types';

export const getAOIS = (aoiStr: string): AreaOfInterest[] => {
  return JSON.parse(aoiStr);
};

export const handleAOIResponse = (aoisStr: string): AreaOfInterest[] => {
  const aois = JSON.parse(aoisStr);
  return aois;
};

export const formValuesToAOI = (formData: AOIFormValues): AreaOfInterest => {
  return {
    ...formData.aoiSelect,
    aoiName: formData.aoiSelect.label,
    id: parseInt(formData.aoiSelect.value),
  };
};

export const specialtiesToOptions = (aoiSpecs: string): OptionType[] => {
  const specs: AoiSpecialty[] = JSON.parse(aoiSpecs);
  return specs.map((spec) => ({ label: spec.aoiSpecialtyName, value: spec.id.toString() }));
};

export const AOISToOptions = (aoiSpecs: string): AoiOptionType[] => {
  const aois: AreaOfInterest[] = JSON.parse(aoiSpecs);
  return aois.map((aoi) => ({
    label: aoi.aoiName,
    value: aoi.id.toString(),
    ...aoi,
  }));
};
